import React, { useMemo } from 'react';
import Joyride, { STATUS, EVENTS, ACTIONS } from 'react-joyride';
import { useTourStore } from '../../store/tourStore';
import { WelcomeTourModal } from './WelcomeTourModal';
import { TourSuccessModal } from './TourSuccessModal';

export const AppTour = () => {
    const {
        isTourActive,
        tourMode,
        stepIndex,
        setStepIndex,
        finishTour,
        completeTour
    } = useTourStore();

    const handleJoyrideCallback = (data) => {
        const { action, index, status, type } = data;

        if (status === STATUS.FINISHED) {
            completeTour();
        } else if (status === STATUS.SKIPPED) {
            // Пользователь пропустил тур
            finishTour();
        } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            // Обновляем шаг при переходе
            const indexNext = index + (action === ACTIONS.PREV ? -1 : 1);
            setStepIndex(indexNext);
        }
    };

    // Формируем шаги на основе выбранного режима
    const steps = useMemo(() => {
        if (!tourMode) return [];

        const baseSteps = [
            {
                target: '.tour-btn-add-org',
                content: 'Добавьте вашу организацию, чтобы корректно формировать документы.',
                disableBeacon: true,
            },
            {
                target: '.tour-btn-add-room',
                content: 'Откройте раздел Склад -> Помещения, чтобы добавить склады.',
            },
            {
                target: '.tour-btn-goods',
                content: 'В разделе Товары и услуги добавьте типы цен (розница, опт) и сами товары.',
            },
            {
                target: '.tour-btn-integrations',
                content: 'Подключите ваши внешние системы через интеграции или CommerceML.',
            }
        ];

        if (tourMode === 'crm') {
            baseSteps.push({
                target: '.tour-btn-chats',
                content: 'Подключите чаты для общения с клиентами.',
            });
        }

        baseSteps.push({
            target: '.tour-btn-invite',
            content: 'Пригласите ваших сотрудников или партнеров в ваш кабинет. На этом базовая настройка завершена!',
        });

        return baseSteps;
    }, [tourMode]);

    return (
        <>
            <WelcomeTourModal />
            <TourSuccessModal />
            <Joyride
                steps={steps}
                run={isTourActive && steps.length > 0}
                stepIndex={stepIndex}
                callback={handleJoyrideCallback}
                continuous={true}
                showSkipButton={true}
                showProgress={false}
                locale={{
                    back: 'Назад',
                    close: 'Закрыть',
                    last: 'Завершить',
                    next: 'Далее',
                    skip: 'Пропустить',
                }}
                styles={{
                    options: {
                        primaryColor: '#1890ff',
                        zIndex: 10000,
                    },
                }}
            />
        </>
    );
};
